/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessTokenEntity
 */
export interface ProcessTokenEntity {
    /**
     * 
     * @type {string}
     * @memberof ProcessTokenEntity
     */
    nodeId: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessTokenEntity
     */
    prevNodeId: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessTokenEntity
     */
    prevAction: string;
    /**
     * 
     * @type {Array<ProcessTokenEntity>}
     * @memberof ProcessTokenEntity
     */
    childProcessTokens: Array<ProcessTokenEntity>;
    /**
     * 
     * @type {object}
     * @memberof ProcessTokenEntity
     */
    currentNodeIds: object;
}

/**
 * Check if a given object implements the ProcessTokenEntity interface.
 */
export function instanceOfProcessTokenEntity(value: object): value is ProcessTokenEntity {
    if (!('nodeId' in value) || value['nodeId'] === undefined) return false;
    if (!('prevNodeId' in value) || value['prevNodeId'] === undefined) return false;
    if (!('prevAction' in value) || value['prevAction'] === undefined) return false;
    if (!('childProcessTokens' in value) || value['childProcessTokens'] === undefined) return false;
    if (!('currentNodeIds' in value) || value['currentNodeIds'] === undefined) return false;
    return true;
}

export function ProcessTokenEntityFromJSON(json: any): ProcessTokenEntity {
    return ProcessTokenEntityFromJSONTyped(json, false);
}

export function ProcessTokenEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessTokenEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'nodeId': json['nodeId'],
        'prevNodeId': json['prevNodeId'],
        'prevAction': json['prevAction'],
        'childProcessTokens': ((json['childProcessTokens'] as Array<any>).map(ProcessTokenEntityFromJSON)),
        'currentNodeIds': json['currentNodeIds'],
    };
}

export function ProcessTokenEntityToJSON(json: any): ProcessTokenEntity {
    return ProcessTokenEntityToJSONTyped(json, false);
}

export function ProcessTokenEntityToJSONTyped(value?: ProcessTokenEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nodeId': value['nodeId'],
        'prevNodeId': value['prevNodeId'],
        'prevAction': value['prevAction'],
        'childProcessTokens': ((value['childProcessTokens'] as Array<any>).map(ProcessTokenEntityToJSON)),
        'currentNodeIds': value['currentNodeIds'],
    };
}

